module.exports = __webpack_public_path__ + "media/images/img/intaview_company/ntt_com-d9f9b8c43ef28d8198bc422293a96050.png";